import { render, staticRenderFns } from "./EmploymentItem.vue?vue&type=template&id=0a7c8686&scoped=true&lang=pug&"
import script from "./EmploymentItem.vue?vue&type=script&lang=ts&"
export * from "./EmploymentItem.vue?vue&type=script&lang=ts&"
import style0 from "./EmploymentItem.vue?vue&type=style&index=0&id=0a7c8686&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7c8686",
  null
  
)

component.options.__file = "EmploymentItem.vue"
export default component.exports